type LogCategory = 'SYSTEM' | 'AUTH' | 'NAVIGATION' | 'DATABASE' | 'ACTION' | 'ERROR';

const COLORS: Record<LogCategory, string> = {
  SYSTEM: '#8b5cf6', // Purple
  AUTH: '#3b82f6', // Blue
  NAVIGATION: '#ec4899', // Pink
  DATABASE: '#10b981', // Green
  ACTION: '#f59e0b', // Amber/Orange
  ERROR: '#ef4444', // Red
};

export const logger = {
  log(category: LogCategory, message: string, ...details: unknown[]) {
    const color = COLORS[category] || '#6b7280';
    const timestamp = new Date().toLocaleTimeString();
    
    if (category === 'ERROR') {
      console.error(
        `%c[${timestamp}] [${category}] %c${message}`,
        `color: ${color}; font-weight: bold;`,
        'color: inherit;',
        ...details
      );
    } else {
      console.log(
        `%c[${timestamp}] [${category}] %c${message}`,
        `color: ${color}; font-weight: bold;`,
        'color: inherit;',
        ...details
      );
    }
  },
  system(message: string, ...details: unknown[]) {
    this.log('SYSTEM', message, ...details);
  },
  auth(message: string, ...details: unknown[]) {
    this.log('AUTH', message, ...details);
  },
  nav(message: string, ...details: unknown[]) {
    this.log('NAVIGATION', message, ...details);
  },
  db(message: string, ...details: unknown[]) {
    this.log('DATABASE', message, ...details);
  },
  action(message: string, ...details: unknown[]) {
    this.log('ACTION', message, ...details);
  },
  error(message: string, ...details: unknown[]) {
    this.log('ERROR', message, ...details);
  }
};
